'use client';

import classNames from '@/utils/classNames';
import BaseButton from '@/components/Button/particles/BaseButton';
import ButtonIcon from '@/components/Button/particles/ButtonIcon';
import type { ButtonWithStaticIcon } from '@/components/Button/types';

const CLASSNAME =
  'bg-blue-600 not-disabled:text-white enabled:text-white disabled:text-white/60 not-disabled:hover:bg-blue-700 focus-visible:outline-blue-600';

const PrimaryButton = (({
  className,
  ref,
  ...props
}: React.ComponentProps<typeof BaseButton>) => (
  <BaseButton
    ref={ref}
    loadingLight
    {...props}
    className={classNames(CLASSNAME, className)}
  />
)) as ButtonWithStaticIcon;

PrimaryButton.displayName = 'PrimaryButton';

PrimaryButton.Icon = ButtonIcon;

export default PrimaryButton;
